import { NavLink } from 'react-router-dom';
import useSession from '@/hooks/useSession';
import styles from './topbar.module.scss';
import { classnames } from '@/utils/functions';
import { FC } from 'react';
import { useConsent } from '@/scaffold/cookie-consent';

interface TopbarProps {
  float?: boolean;
}

const Topbar: FC<TopbarProps> = ({ float = false }) => {
  const { isAuthenticated } = useSession();
  const { openPrefs } = useConsent();

  const links: { label: string; link: string }[] = [
    { label: isAuthenticated ? 'App' : 'Sign In', link: '/' },
  ];

  return (
    <nav className={classnames(styles['topbar'], { [styles['float']]: float })}>
      {links.map(({ label, link }) => (
        <NavLink key={link} className={styles['link']} to={link}>
          {label}
        </NavLink>
      ))}
      <NavLink
        to="/"
        className={styles['link']}
        onClick={(e) => {
          e.preventDefault();
          openPrefs();
        }}
      >
        Cookie Preferences
      </NavLink>
    </nav>
  );
};

export default Topbar;
